import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import BusinessProvinceProxy from './proxy'

class BusinessProvinceService extends ServiceBase {
  getBusinessProvinceTable(params) {
    return this.getData(() =>
      BusinessProvinceProxy.getBusinessProvinceTable(params),
    )
  }

  downloadBusinessProvince(params) {
    return this.getFileDownload(() =>
      BusinessProvinceProxy.downloadBusinessProvince(params),
    )
  }
}

export default new BusinessProvinceService()
